import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-attr-logical',
  templateUrl: './attr-logical.component.html',
  styleUrls: ['./attr-logical.component.scss'],
  standalone: false,
})
export class AttrLogicalComponent implements OnInit {
  @Input() propertyId: string;
  @Input() caption: string;
  @Input() value: string;
  @Input() mandatory: boolean;
  @Input() isDisabled: boolean;

  valueBool: boolean;

  constructor() {}

  ngOnInit(): void {
    if (this.value === 'true') {
      this.valueBool = true;
    }
    if (this.value === 'false') {
      this.valueBool = false;
    }
  }

  onValueChanged() {
    this.value = this.valueBool ? 'true' : 'false';
  }
}
